<script lang="ts" setup>
import { FormKitLazyProvider } from '@formkit/vue'
import type { FormSpecialDealerSelector } from '~/composables/useForm'
import FormKitDealerSelector from './kit/FormKitDealerSelector.vue'

const props = defineProps<{
  data: FormSpecialDealerSelector
}>()

const emit = defineEmits(['next'])

const { t } = useI18n()

// Cast as any because there is no typescript support for custom FormKit input
const dealerSelectorType: any = createInput(FormKitDealerSelector)
function cannotBeEmptyObject({ value }: { value: any | undefined }) {
  return !!value
}

const dealer = ref<any>(null)
</script>

<template>
  <div class="flex flex-col gap-2.4rem">
    
<FormKitLazyProvider config-file="true">
<FormKit
      :id="props.data.key"
      :type="dealerSelectorType"
      :name="props.data.key"
      validation="cannotBeEmptyObject"
      :validation-rules="{
        cannotBeEmptyObject,
      }"
      @input="dealer = $event"
    />
    <div class="grid grid-cols-1 gap-5rem lg:grid-cols-[5fr_4fr]">
      <div>
        <!-- <pre>{{ dealer }}</pre> -->
      </div>
      <button
        :disabled="!dealer"
        class="mt-auto block border border-neutral-white px-2.5rem py-1.25rem text-center text-1.3rem text-neutral-white tracking-4px uppercase transition duration-300 block-light:border-neutral-black block-light:text-neutral-black hover:bg-neutral-white hover:text-neutral-black block-light:hover:bg-neutral-black block-light:hover:text-neutral-white"
        :class="!dealer ? 'opacity-20 cursor-not-allowed' : ''"
        @click="emit('next')"
      >
        {{ t('form.dealers.next') }}
      </button>
    </div>
</FormKitLazyProvider>

  </div>
</template>

<style>

</style>
